package hk.com.vr360_demo2.webapp.component.previewer

import cc.easyandroid.easycompose.component.ComponentContext
import hk.com.vr360_demo2.webapp.core.ui_state.UIComponent
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.emptyFlow

interface PreviewerComponent {
    val url: String
    val autorotateEnabled: Boolean
    val state: StateFlow<PreviewerState>
    val errors: Flow<UIComponent>
    fun dispatch(intent: PreviewerIntent)
}

class DefaultPreviewerComponent(
    context: ComponentContext,
    override val url: String,
    override val autorotateEnabled: Boolean = false,
) : PreviewerComponent, ComponentContext by context {

    private val stateFlow = MutableStateFlow(
        PreviewerState(
            url = url,
            autorotateEnabled = autorotateEnabled,
        )
    )

    override val state: StateFlow<PreviewerState> = stateFlow
    override val errors: Flow<UIComponent> = emptyFlow()

    override fun dispatch(intent: PreviewerIntent) = Unit
}
